export const getIsIframeLoaded = iframe => {
  var _iframe$contentDocume;
  if (!iframe) {
    return false;
  }
  return !!((_iframe$contentDocume = iframe.contentDocument) !== null && _iframe$contentDocume !== void 0 && _iframe$contentDocume.body);
};